import {useEffect,useState,type ReactNode} from 'react';
import {Pin,PinOff} from 'lucide-react';
import {RoomEvent,type Room,type Participant} from 'livekit-client';
import './participant-grid.css';

export function ParticipantGrid({room,participants,strip=false,renderTile}:{room:Room|null;participants:Participant[];strip?:boolean;renderTile:(person:Participant)=>ReactNode}) {
  const [active,setActive]=useState<{room:Room|null;identities:string[]}>({room:null,identities:[]});
  const [pin,setPin]=useState<{room:Room|null;identity:string}|null>(null);
  useEffect(()=>{
    if(!room)return;
    let timer:ReturnType<typeof setTimeout>|undefined;
    const update=(speakers:Participant[])=>{
      clearTimeout(timer);
      const identities=speakers.map(person=>person.identity);
      timer=setTimeout(()=>setActive({room,identities}),identities.length?150:600);
    };
    const disconnected=(person:Participant)=>setPin(current=>current?.room===room&&current.identity===person.identity?null:current);
    room.on(RoomEvent.ActiveSpeakersChanged,update);
    room.on(RoomEvent.ParticipantDisconnected,disconnected);
    update(room.activeSpeakers || []);
    return()=>{clearTimeout(timer);room.off(RoomEvent.ActiveSpeakersChanged,update);room.off(RoomEvent.ParticipantDisconnected,disconnected);};
  },[room]);
  const chosen=!strip&&pin?.room===room?participants.find(person=>person.identity===pin.identity):undefined;
  const tile=(person:Participant)=>{
    const speaking=active.room===room&&active.identities.includes(person.identity);
    const pinned=person===chosen;
    const name=person.name||'Участник';
    const action=`${pinned?'Открепить':'Закрепить'}: ${name}`;
    return <div key={person.identity} className={`participant-grid-item${speaking?' participant-grid-item--speaker':''}`} data-participant={person.identity} aria-label={`${name}${speaking?' — говорит':''}`}>
      {renderTile(person)}
      {!strip&&participants.length>1&&<button type="button" className="participant-pin" aria-label={action} title={action} aria-pressed={pinned} onClick={()=>setPin(pinned?null:{room,identity:person.identity})}>{pinned?<PinOff size={20}/>:<Pin size={20}/>}</button>}
    </div>;
  };
  if(chosen)return <div className="participant-layout participant-layout--pinned" data-pinned={chosen.identity}>
    <div className="participant-featured">{tile(chosen)}</div>
    {participants.length>1&&<div className="call-grid participant-grid call-grid--strip participant-grid--strip" aria-label="Другие участники">{participants.filter(person=>person!==chosen).map(tile)}</div>}
  </div>;
  return <div className={`call-grid participant-grid${strip?' call-grid--strip participant-grid--strip':''}`} data-participants={participants.length}>{participants.map(tile)}</div>;
}
